<template>
  <div class="container">
    <div class="info">
      <div class="tit">{{ $t('finance').Loanrecords }}</div>
      <!-- 顶部 -->
      <div class="top">
        <!-- tab切换 -->
        <div class="tabs"><span v-for="(item, index) in tabs" :key="`tab${index}`" :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}</span></div>
      </div>
      <!-- 列表 -->
      <div class="listInfo">
        <!-- 产品标题 -->
        <div class="title">
          <!-- <span>{{ $t('finance').Dailyinterestrate }}</span> -->
          <!-- <span>{{ $t('finance').term }}</span> -->
          <span>{{ $t('finance').LoanAmount }}</span>
          <span>{{ $t('finance').LoanDate }}</span>
          <!-- <span>{{ $t('finance').duedate }}</span> -->
        </div>
        <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getLoanOrderList" :immediate-check="false">
          <div class="item" v-for="(dItem, dIndex) in oList" :key="`fiorder${dIndex}`" @click="toOrderInfo(dItem)">
            <!-- <span>{{ dItem.interest }}%</span> -->
            <!-- <span>{{ dItem.days }} {{ $t('finance').day }}</span> -->
            <span>{{ dItem.amount }} USDT</span>
            <span>{{  orderInfo.createTime | getLocalTime }}</span>
            <!-- <span>{{ dItem.maturityTime | getLocalDate }}</span> -->
          </div>
        </van-list>
      </div>
      <!-- 订单详情 -->
      <van-popup v-model="showOrderInfo" closeable position="center" style="width: 500px;">
        <div class="orderInfo">
          <!-- 状态 -->
          <div class="status">{{
            orderInfo.status == 1 ? $t('finance').Pendingreview : orderInfo.status == 2 ? $t('finance').issued :
              orderInfo.status == 3 ? $t('finance').Repaid :
                orderInfo.status == 4 ? $t('finance').Rejected : '' }}
          </div>
          <!-- 日利息率 -->
          <!-- <div class="item">{{ $t('finance').Dailyinterestrate }}<span>{{ orderInfo.interest }}%</span></div> -->
          <!-- 期限 -->
          <!-- <div class="item">{{ $t('finance').term }}<span>{{ orderInfo.days }} {{ $t('finance').day }}</span></div> -->
          <!-- 借款金额 -->
          <div class="item">{{ $t('finance').LoanAmount }}<span>{{ orderInfo.amount }} USDT</span></div>
          <!-- 借款日 -->
          <div class="item">{{ $t('finance').LoanDate }}<span>{{ orderInfo.createTime | getLocalTime }}</span>
          </div>
          <!--到期日 -->
          <!-- <div class="item">{{ $t('finance').duedate }}<span>{{ orderInfo.maturityTime | getLocalDate }}</span></div> -->
          <!-- 总利息 -->
          <!-- <div class="item">{{ $t('finance').Totalinterest }}<span>{{ orderInfo.revenueAmount }}   USDT</span></div> -->
          <!-- 应还金额 -->
          <!-- <div class="item">{{ $t('finance').AmountDue }}<span>{{ orderInfo.settleAmount }}   USDT</span></div> -->
          <!-- 订单编号 -->
          <div class="item">{{ $t('position').orderno }} <span>{{ orderInfo.loanOrderNo }}</span></div>
          <!-- 还款 -->
          <div class="btn" v-if="orderInfo.status == 2" @click="goServe">{{ $t('finance').repayment }}</div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import orderApi from '@/api/order'
import userApi from '@/api/user'
export default {
  components: {
  },
  data() {
    return {
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
      orderInfo: {},
      showOrderInfo: false,
      active: "1",
      tabs: [{
        "name": this.$t('finance').Pendingreview,
        "value": "1"
      }, {
        "name": this.$t('finance').issued,
        "value": "2"
      }, {
        "name": this.$t('finance').Repaid,
        "value": "3"
      }, {
        "name": this.$t('finance').Rejected,
        "value": "4"
      },
      ],
    }
  },
  mounted() {
    this.getLoanOrderList()
  },
  methods: {
    //切换
    changeTab(val) {
      this.active = val
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getLoanOrderList()
    },
    // 获取贷款订单记录
    async getLoanOrderList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.status = this.active
      const res = await orderApi.getLoanOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
    //查看订单详情
    toOrderInfo(val) {
      this.orderInfo = val
      this.showOrderInfo = true
    },
    // 客服
    async goServe() {
      const res = await userApi.getMemberInfo()
      const encodedData = JSON.stringify({ name: res.user.memberId, email: res.user.memberName });
      location.href = 'chatlinkonline.html?metadata=' + encodedData
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-top: 110px;
  padding-bottom: 100px;

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .tit {
      font-size: 36px;
      font-weight: bold;
      color: var(--text_color);
    }
  }

  .top {
    padding-top: 50px;
    width: 100%;
    background: var(--background_color);

    .tabs {
      padding: 0 15px;
      font-size: 16px;
      font-weight: bold;
      color: var(--ntext_color);
      border-bottom: 1px solid var(--info_color);
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;

      span {
        display: inline-block;
        text-align: center;
        padding: 12px 0;
        margin-right: 50px;
      }

      .active {
        color: var(--primary_color);
        padding-bottom: 10px;
        border-bottom: 2px solid var(--primary_color);
      }
    }
  }

  .listInfo {
    .title {
      padding: 0 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--ntext_color);
      font-size: 14px;
      height: 50px;
      border-bottom: 1px solid var(--info_color);

      span {
        width: 20%;
      }
    }

    .item {
      padding: 30px 15px;
      border-bottom: 1px solid var(--info_color);
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: var(--text_color);

      span {
        width: 20%;
      }

      &:hover {
        background: var(--info_color);
      }
    }
  }

  .orderInfo {
    padding: 30px;

    .status {
      font-size: 18px;
      font-weight: bold;
      color: var(--primary_color);
      text-align: center;
    }

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      font-size: 15px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
      }
    }

    .btn {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      border-radius: 20px;
      font-size: 15px;
      color: #fff;
      background: var(--primary_color);
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--info_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}
</style>
